'use strict';

const needAnswer = {
    elements: {
        needAnswer : $('.js-need-answers')
    },

    selectors: {
        questionHeader : '.question-wrap__header',
        questionWrap : '.question-wrap'
    },

    init() {
        this.initEvent();
    },

    initEvent() {
        this.elements.needAnswer.on('click', this.selectors.questionHeader, this.expandAnswerBody.bind(this));
    },

    expandAnswerBody (e) {
        const currentButton = $(e.currentTarget);
        const questionWrap = currentButton.closest(this.selectors.questionWrap);

        questionWrap.toggleClass('question-wrap__expanded');

        const isExpanded = questionWrap.hasClass('question-wrap__expanded');
        currentButton.attr('aria-expanded', isExpanded ? 'true' : 'false');
    },
};

needAnswer.init();
export default needAnswer;
